import { fork } from 'redux-saga/effects';
import { initializationSaga } from './initializationSaga';
import { logInSaga } from './logInSaga';
import { powerBiSaga } from './powerBiSaga';

const sagas = [initializationSaga, logInSaga, powerBiSaga];

export function* getRootSaga() {
    for (const saga of sagas) {
        yield fork(saga);
    }
}
